/* Antes de build quita el usuario y la clave de formulario login */
const modoTest = false; // true  ||  false
const cliente = "icovdlp.com" 
export const HTTP = {
    api_url: modoTest ? 'http://127.0.0.1:8000/api/' : 'https://api.' + cliente + '/api/',    
}
//http://127.0.0.1:8000/api/
//https://api.icovdlp.com/api/